module.exports = __webpack_public_path__ + "media/images/favicon-50b3ff5e84e291e61a770965bd3b6150.ico";